module.exports = __webpack_public_path__ + "static/img/L02.cd60831.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/L02.jpg
// module id = zfC7
// module chunks = 9